import Modal from "react-overlays/Modal";
import Icon from "./icon";

const renderBackdrop = (props) => <div className="backdrop" {...props} />;

const DeleteRequestModal = ({
  show,
  closeModal,
  labels,
  request,
  object = { deleteRequest: () => 0, isError: false, reset: () => 0, isLoading: false },
}) => {
  const { deleteRequest, isError, reset, isLoading } = object;

  const handleDeleteRequest = async () => {
    await deleteRequest(request);
    if (!isError) {
      closeModal();
    }
    reset();
  };

  return (
    <Modal
      show={show}
      onHide={closeModal}
      aria-labelledby="modal-label"
      className="modal modal--borse dark-mode"
      renderBackdrop={renderBackdrop}
      onBackdropClick={closeModal}
      aria-hidden="false"
      aria-modal="true"
    >
      <>
        <button
          type="button"
          onClick={closeModal}
          className="close-button"
          aria-label={labels?.CLOSE}
        >
          <Icon name="cross" />
        </button>
        <div className="modal__body wrapper">
          <h1 className="modal__title">
            {labels?.WELFARE_BORSE_DELETE_REQUEST_MODAL_TITLE ||
              "Do you want to delete your request?"}
          </h1>
          <div className="modal__buttons">
            <button className="button secondary" onClick={closeModal}>
              {labels?.WELFARE_DISCARD || "No, keep it"}
            </button>
            <button className="button primary" onClick={handleDeleteRequest}>
              {isLoading && <span className="loading-spinner" />}
              {labels?.WELFARE_DELETE_SUBMISSION || "Yes, delete"}
              <Icon name="trash" />
            </button>
          </div>
          {isError && (
            <p className="modal__error">
              {labels?.WELFARE_BORSE_ERROR_DELETING_REQUEST || "Error deleting request"}
            </p>
          )}
        </div>
      </>
    </Modal>
  );
};

export default DeleteRequestModal;
